import { responsiveImageInputs } from "@/libs/builder/common/responsiveImageInputs";

export const inputs = [
  {
    name: "text",
    type: "string",
    defaultValue: "",
  },
  {
    name: "link",
    type: "url",
    defaultValue: "",
  },
  {
    name: "image",
    type: "object",
    subFields: responsiveImageInputs,
  },
] as const satisfies Inputs;

export type FindStoreBannerProps = BuilderComponentProps<typeof inputs>;
